// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1FPfM","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2Czlf"};